import { AttributeConfiguration as e } from "@microsoft/fast-element";
function n(r, ...p) {
  const c = e.locate(r);
  p.forEach((o) => {
    Object.getOwnPropertyNames(o.prototype).forEach((t) => {
      t !== "constructor" && Object.defineProperty(
        r.prototype,
        t,
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        Object.getOwnPropertyDescriptor(o.prototype, t)
      );
    }), e.locate(o).forEach((t) => c.push(t));
  });
}
export {
  n as applyMixins
};
